var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"summaryTitle"},[_c('span',{staticClass:"no1 block"}),_c('span',{staticClass:"no2 block"}),_c('span',{staticClass:"no3 block"}),_c('span',{staticClass:"name"},[_vm._v(_vm._s(_vm.title))]),_c('span',{staticClass:"no3 block"}),_c('span',{staticClass:"no2 block"}),_c('span',{staticClass:"no1 block"})])
}
var staticRenderFns = []

export { render, staticRenderFns }